import { ShieldCheck, Award } from 'lucide-react';
import { certifications } from '../../data/mock';
import { useInView } from '../../hooks/useInView';

const certIcons = {
  'ISO 9001:2015': '9001',
  'BIS': 'BIS',
  'ERDA': 'ERDA',
  'CPRI': 'CPRI',
  'NTH': 'NTH',
};

export const CertificationsSection = () => {
  const [ref, isInView] = useInView();

  return (
    <section id="certifications" className="py-20 lg:py-28 bg-navy-950 relative overflow-hidden" ref={ref}>
      <div className="absolute inset-0 industrial-pattern" />
      <div className="absolute top-0 right-0 w-96 h-96 bg-ind-red-600/5 rounded-full blur-[120px]" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className={`text-center mb-14 ${isInView ? 'animate-fade-in-up' : 'opacity-0'}`}>
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-10 h-[2px] bg-ind-red-600" />
            <span className="text-sm font-semibold text-ind-red-400 uppercase tracking-wider">Certifications</span>
            <div className="w-10 h-[2px] bg-ind-red-600" />
          </div>
          <h2 className="font-heading font-extrabold text-white text-3xl lg:text-4xl mb-3">
            Approvals & Certifications
          </h2>
          <p className="text-navy-400 text-base max-w-xl mx-auto">
            Every batch is quality tested as per Indian Standards before dispatch.
          </p>
        </div>

        {/* Certification Cards */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 lg:gap-6">
          {certifications.map((cert, idx) => (
            <div
              key={cert.name}
              className={`cert-badge bg-navy-900/60 backdrop-blur-sm border border-navy-800 rounded-2xl p-6 text-center group hover:border-ind-red-600/30 ${
                isInView ? 'animate-fade-in-up' : 'opacity-0'
              }`}
              style={{ animationDelay: `${idx * 0.1}s` }}
            >
              <div className="w-16 h-16 rounded-xl bg-navy-800 mx-auto flex items-center justify-center mb-4 group-hover:bg-ind-red-600/10 border border-navy-700 group-hover:border-ind-red-600/30 transition-colors duration-300">
                <span className="font-heading font-extrabold text-ind-red-400 text-sm">
                  {certIcons[cert.name]}
                </span>
              </div>
              <h3 className="font-heading font-bold text-white text-sm mb-1">{cert.name}</h3>
              <p className="text-xs text-navy-400">{cert.description}</p>
            </div>
          ))}
        </div>

        {/* Bottom trust note */}
        <div className={`mt-12 text-center ${isInView ? 'animate-fade-in-up' : 'opacity-0'}`} style={{ animationDelay: '0.5s' }}>
          <div className="inline-flex items-center gap-2 bg-navy-900/60 border border-navy-800 rounded-full px-6 py-3">
            <ShieldCheck className="w-4 h-4 text-ind-red-400" />
            <span className="text-sm text-navy-200 font-medium">
              All products tested at ERDA, CPRI & NTH approved laboratories
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};
